module.exports = __webpack_public_path__ + "static/media/01.beca54d7.png";